import apiClient from '@/services/api-client';

export const getSupplier = async () => {
  const response = await apiClient.get('/supplier/get');
  return response.data;
};


export const getCurrentSupplier = async () => {
  const response = await apiClient.get('/supplier/get/current');
  return response.data;
};

export const getAllSupplier = async (params) => {
  const response = await apiClient.get('/supplier/list', {params});
  return response.data;
};

export const saveSuppliers = async (body, params) => {
  const response = await apiClient.post('/supplier/save', body, { params: params});
  return response.data;
};

export const updateCurrentSupplier = async (body) => {
  const response = await apiClient.post('/supplier/update', body);
  return response.data;
};

export const uploadLogo = async (formData, supplierId) => {
  const response = await apiClient.post(`/supplier/upload-logo/${supplierId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};